export const formatOpponentLevelCue = (level: number): string =>
  `Lv ${String(level)}`;

export const isOpponentCueVisible = (
  playerPosition: { readonly x: number; readonly y: number },
  opponentPosition: { readonly x: number; readonly y: number },
  visibilityDistance: number,
): boolean =>
  Math.hypot(
    opponentPosition.x - playerPosition.x,
    opponentPosition.y - playerPosition.y,
  ) <= visibilityDistance;
